import { SearchCasesDto } from "types/dto/SearchCasesDto";
import { ApiService } from "./apiService";
import { GetCasesDto } from "types/dto/GetCasesDto";
import { ExportDto } from "types/dto";
import { GetReportsDto } from "types/dto/GetReportsDto";

export const searchCases = async (searchDto: SearchCasesDto, options = {}) => {
  return await ApiService.get(`users/${searchDto.userId}/procedures?page=${searchDto.page}&page_size=${searchDto.pageLimit}&filter=${searchDto.filter}&search_by=${searchDto.search_by}&value=${searchDto.value}`, options);
};

export const getCases = async (getCasesDto: GetCasesDto, options = {}) => {
  return await ApiService.get(`users/${getCasesDto.userId}/procedures?page=${getCasesDto.page}&page_size=${getCasesDto.pageLimit}&filter=${getCasesDto.filter}&search_by=${getCasesDto.search_by}&before=${getCasesDto.before ?? ''}&start_date=${getCasesDto.start_date ?? ''}&end_date=${getCasesDto.end_date ?? ''}&value=${getCasesDto.value}&sort_by=${getCasesDto.sort_by}`, options);
}

export const getReports = async (dto: GetReportsDto) => {
  const { userId, page, pageLimit } = dto;
  if (page && pageLimit) {
    const { data } = await ApiService.get(`users/${userId}/procedures/reports?page=${page}&page_size=${pageLimit}`);
    return data;
  } else {
    const { data } = await ApiService.get(`users/${userId}/procedures/reports`);
    return data;
  }
}

export const exportCases = async (userId: number, dto: ExportDto) => {
  return await ApiService.post(`users/${userId}/procedures/export`, dto);
}